import { FC } from 'react';
import { Box, Button, Grid, List } from '@mui/material';
import ButtonWithOptions from 'components/ButtonWithOptions';
import SimpleLoadingButton from 'components/LoadingButton';
import { FormAction, FormContent, FormNavigation, StyledForm } from 'components/TabsFormWithSubMenu/styled';
import { TabsFormProps } from 'components/TabsFormWithSubMenu/types';
import ListItems from './components/ListItems';

const TabsFormWithSubMenu: FC<TabsFormProps> = (props) => {
  return (
    <StyledForm>
      <form onSubmit={props.handleSubmit} autoComplete={props.autoComplete}>
        <Grid container columns={13}>
          <FormNavigation item md={3}>
            <List component='nav' aria-label='main mailbox folders'>
              {props.tabs.map((tab, index) => (
                <ListItems
                  key={`vertical-list-tabs-keys-${index}`}
                  activeTab={props.activeTab}
                  index={index}
                  handleChange={props.handleChange}
                  tab={tab}
                />
              ))}
            </List>
          </FormNavigation>
          <FormContent item md={10}>
            {props.tabs.map((tab, index) => (
              <Box key={index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`}>
                {props.activeTab === tab.index && <Box>{tab.content}</Box>}
              </Box>
            ))}
          </FormContent>
        </Grid>
        <FormAction>
          <Button sx={{ 'border-radius': '4px' }} data-test="Cancel-button" variant='outlined' disabled={props.isSubmitting} onClick={props.handleCancel}>
            {props.cancelLabel || 'Cancel'}
          </Button>
          {Array.isArray(props.actionLabel) && (
            <ButtonWithOptions
              disabled={props.isSubmitting || props.isDisabled}
              options={props.actionLabel}
              handleConfirmChoice={props.handleSubmit}
            />
          )}
          {!Array.isArray(props.actionLabel) && (
            <SimpleLoadingButton
              type='submit'
              isLoading={props.isSubmitting || false}
              disabled={props.isSubmitting || props.isDisabled}
              dimensions={{ width: 180, height: 40 }}
              variant='contained'
              name={props.actionLabel}
            >
              {props.actionLabel}
            </SimpleLoadingButton>
          )}
        </FormAction>
      </form>
    </StyledForm>
  );
};

export default TabsFormWithSubMenu;
